import React, {useCallback, useState} from 'react';
import {DataTable, DataTableSortStatus} from 'mantine-datatable';
import {DataComponentProps, PagedDataTableConfig} from './types.ts';
import {BoxMod} from '@mantine/core';
import {AnyObject} from '../../types';

export function DefaultTableView<TDto extends AnyObject>(
  props: DataComponentProps<TDto>
) {
  const {config, onSortChange, sort, records, fetching} =
    props;

  const [sortStatus, setSortStatus] = useState<DataTableSortStatus<TDto>>({
    columnAccessor: sort?.column ?? '',
    direction: sort?.direction === 'ASC' ? 'asc' : 'desc',
  });

  const onSortStatusChange = useCallback(
    (newSortStatus: DataTableSortStatus<TDto>) => {
      setSortStatus(newSortStatus);
      onSortChange({
        column: newSortStatus.columnAccessor as keyof TDto,
        direction: newSortStatus.direction === 'asc' ? 'ASC' : 'DESC',
      });
    },
    [onSortChange]
  );

  const {rowProps, columns, noHeader, emptyState} = config;

  return (
    <DataTable<TDto>
      storeColumnsKey={config.tableKey}
      columns={columns}
      fetching={fetching}
      records={records}
      minHeight={records.length === 0 ? 200 : undefined}
      sortStatus={sortStatus}
      onSortStatusChange={onSortStatusChange}
      highlightOnHover={Boolean(config.rowProps?.onRowClick)}
      mod={getModAttributes(config)}
      emptyState={emptyState}
      noHeader={noHeader}
      {...rowProps}
    />
  );
}

const getModAttributes = <TDto,>(
  config: PagedDataTableConfig<TDto>
): BoxMod => ({
  clickable: Boolean(config.rowProps?.onRowClick),
});